var markerUrls = {
  restaurant: '/web/pins/pin_restaurant'
};
var markerUrlsNoColour = {
  restaurant: '/web/pins/nocolour/pin_restaurant'
};

export { markerUrls, markerUrlsNoColour };
//# sourceMappingURL=markerUrls.js.map
